import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { staffApi } from '../../lib/http';
import { PortalCard, PortalEmpty, PortalStat } from '../../components/portal/PortalElements';

export default function StaffDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    staffApi
      .get('/staff/dashboard')
      .then((response) => setData(response.data))
      .catch((requestError) => setError(requestError.message || 'Unable to load staff dashboard.'));
  }, []);

  return (
    <div className="portal-stack">
      <section className="portal-grid portal-grid-stats">
        <PortalStat label="Today's Reservations" value={data?.todaysReservations ?? 0} />
        <PortalStat label="Today's Check-ins" value={data?.todaysCheckins ?? 0} tone="success" />
        <PortalStat label="Pending Check-ins" value={data?.pendingCheckins ?? 0} tone="warm" />
        <PortalStat label="Walk-ins Today" value={data?.walkInsToday ?? 0} />
      </section>

      {error ? <div className="portal-error">{error}</div> : null}

      <section className="portal-grid portal-grid-main">
        <PortalCard>
          <p className="portal-kicker">Primary action</p>
          <h2>Scan the next guest</h2>
          <p className="portal-muted">Validate the QR token and complete check-in from the staff scanner.</p>
          <Link className="portal-inline-link" to="/staff/scanner">
            Open scanner
          </Link>
        </PortalCard>
        <PortalCard>
          <div className="portal-section-head">
            <div>
              <p className="portal-kicker">Recent check-ins</p>
              <h2>Latest activity</h2>
            </div>
          </div>
          {(data?.recentCheckins || []).length ? (
            <div className="portal-list">
              {data.recentCheckins.map((item) => (
                <div key={`${item.bookingId}-${item.checkedInAt}`} className="portal-list-item">
                  <div>
                    <strong>{item.customerName}</strong>
                    <p>{item.bookingId} · {item.time}</p>
                  </div>
                  <span className="portal-muted">{item.status}</span>
                </div>
              ))}
            </div>
          ) : (
            <PortalEmpty title="No recent check-ins" body="Completed check-ins will appear here." />
          )}
        </PortalCard>
      </section>
    </div>
  );
}
